/**
 * AuthImg — admin-only media thumbnail that authenticates with the SAME
 * session as every other admin API call. <img src> cannot carry the OAuth
 * Bearer header, so the binary is fetched as a blob through adminClient
 * (production fix: unauthenticated <img> hits were feeding the admin
 * lockout and blocking uploads).
 */
import React, { useEffect, useState } from "react";
import { mediaBlobUrl } from "../../lib/api";

export const AuthImg = ({ token, userToken = null, assetId, kind = "thumb_webp",
                          className = "", alt = "", ...rest }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let dead = false;
    setFailed(false);
    mediaBlobUrl(token, assetId, kind, userToken)
      .then((u) => { if (!dead) setSrc(u); })
      .catch(() => { if (!dead) setFailed(true); });
    return () => { dead = true; };
  }, [assetId, kind, token, userToken]);
  if (failed) {
    return (
      <div className={`${className} flex items-center justify-center bg-[#0d0c0a] text-[#454038] font-mono text-[8px]`}
           data-testid={`auth-img-failed-${assetId}`}>N/A</div>
    );
  }
  if (!src) return <div className={`${className} bg-[#14120f] animate-pulse`} />;
  return <img src={src} alt={alt} className={className} data-testid={`auth-img-${assetId}`} {...rest} />;
};

export default AuthImg;
